import {
  list,
  changeStatus,
  getStatus,
  refresh,
  protectAll,
  unprotectAll,
  backupAll,
  backupAllActiveSeats,
  exportSnapshot
} from "@/services/api/app/google/seat-management/classroom";
import {defaultPagination} from "@/services/pagination";

const defaultState = () => ({
  classrooms: [],
  pagination: {
    ...defaultPagination(),
    sortBy: 'name',
    sortDescending: false
  },
  search: null,
  filter: {
    statuses: null,
  },
  status: null
});

export default {
  namespaced: true,

  actions: {
    list({commit, state},) {
      return list({
        pagination: state.pagination,
        filter: state.filter,
        search: state.search
      })
        .then(({result, pagination}) => {
          const classrooms = result.reduce((acc, classroom) => {
            return [
              ...acc,
              {
                ...classroom,
                totalSize: classroom?.drive?.size
              }
            ]
          }, [])

          commit('setClassrooms', classrooms)
          commit('setPagination', pagination)
        })
    },
    getStatus({commit}) {
      return getStatus()
        .then(result => {
          commit('setStatus', result)
        })
    },
    refresh({commit}) {
      return refresh()
    },
    changeStatus({commit}, data) {
      return changeStatus(data)
    },
    backupAll() {
      return backupAll()
    },
    backupAllActiveSeats() {
      return backupAllActiveSeats()
    },
    protectAll() {
      return protectAll();
    },
    unprotectAll() {
      return unprotectAll();
    },
    exportSnapshot({commit, state}, {filter, search, pagination}) {
      return exportSnapshot(filter, search, pagination)
    },
  },

  mutations: {
    setClassrooms(state, classrooms) {
      state.classrooms = classrooms;
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    resetPagination(state) {
      state.pagination = {
        ...defaultPagination(),
        sortBy: 'name',
        sortDescending: false
      };
    },
    setSearch(state, search) {
      state.search = search;
    },
    setFilter(state, filter) {
      state.filter = filter;
    },
    setStatus(state, status) {
      state.status = status
    },
    setClassroomsStatus(state, {classroom, status}) {
      state.classrooms = state.classrooms.map(u => {
        if (u.classroomId === classroom.classroomId) {
          return {
            ...u,
            status: status.value
          }
        }

        return u;
      })
    },
    resetState(state) {
      Object.assign(state, defaultState())
    },
  },


  state: defaultState()
}
